// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1etxK","importantInfo":"styles_importantInfo__2NN10"};